import React, { useState, useEffect } from 'react';
import withDashboardMenuLayout from '../../fibe-ui/layout/withDashboardMenuLayout';
import ConvUICard from '../bs-3.0-conv-ui/conv-ui-card';

// IMPORTS: Lottie JSONs for Ack Screen
import PinkAckErrJSON from '../../assets/fibo/ack-fibo-error.json';
import GreenAckErrJSON from '../../assets/fibo/fibo-one-click-le-success.json';
import OrangeAckErrJSON from '../../assets/fibo/ack-orange-fibo-clapping.json';
import { useNavigate } from 'react-router-dom';

// IMPORTS: Desktop Screen Imports
import BgPinkScreenDesktop from '../../assets/ack-screen-bg/pink-bg-ack-screen.svg';
import BgOrangeScreenDesktop from '../../assets/ack-screen-bg/orange-bg-ack-screen.svg';
import BgGreenScreenDesktop from '../../assets/ack-screen-bg/green-bg-ack-screen.svg';
// IMPORTS: Mobile Screen Imports
import BgPinkScreenMobile from '../../assets/mobile-ack-screen-bg/mobile-pink-bg-ack-screen.svg';
import BgOrangeScreenMobile from '../../assets/mobile-ack-screen-bg/mobile-orange-bg-ack-screen.svg';
import BgGreenScreenMobile from '../../assets/mobile-ack-screen-bg/mobile-green-bg-ack-screen.svg';
import { useLEQuestionsStore } from '../../redux';

const OneClickAutoLimitEnhance = () => {
  const navigate = useNavigate();
  const { leQuestionsState } = useLEQuestionsStore();

  const { auto_limit_enhanceAPICall } = leQuestionsState;
  const { response } = auto_limit_enhanceAPICall;

  const [ackScreenData, setAckScreenData] = useState({
    statusDes: '',
    statusMsg: '',
    statusCode: -1,
  });

  const [AckBackgroundSrc, setAckBackgroundSrc] = useState('');
  const [FiboLottieToShow, setFiboLottieToShow] = useState(null);
  const [CTATextToShow, setCTATextToShow] = useState('Okay, got it!');

  /**
   * Navigate to Dashboard on CTA Click, for both the CTAs
   * `Okay, got it!` and `Retry`
   */
  const ctaClickHandler = () => {
    navigate('/dashboard');
  };

  /**
   * Set the Ack Screen Data, based on the API Response
   */
  useEffect(() => {
    setAckScreenData({ ...response });
    const { statusCode } = response;
    if (!statusCode) navigate('/dashboard');
    if (statusCode === 200) {
      setCTATextToShow('Okay, got it!');
      setFiboLottieToShow(GreenAckErrJSON);
      if (window.innerWidth > 600) {
        setAckBackgroundSrc(BgGreenScreenDesktop);
      } else {
        setAckBackgroundSrc(BgGreenScreenMobile);
      }
    } else {
      setCTATextToShow('Retry');
      setFiboLottieToShow(PinkAckErrJSON);
      if (window.innerWidth > 600) {
        setAckBackgroundSrc(BgPinkScreenDesktop);
      } else {
        setAckBackgroundSrc(BgPinkScreenMobile);
      }
    }
  }, []);

  const { statusCode, statusDes, statusMsg } = ackScreenData;
  return withDashboardMenuLayout({
    isLeftProgressBarPresent: false,
    childComponent: (
      <>
        {AckBackgroundSrc ? (
          <div className="absolute w-full h-full flex justify-center items-center">
            <img
              className="h-full absolute object-cover left-0 right-0 top-0 z-[0] w-full "
              src={AckBackgroundSrc}
            />
          </div>
        ) : (
          ''
        )}
        <div className="mt-auto z-10">
          <ConvUICard
            typeOfCard="ACK"
            inputType="component"
            welcomeImagePresent={true}
            welcomeImageLottieData={FiboLottieToShow}
            mainQuestion={statusMsg}
            questionsSubDetails={statusDes}
            buttonText={CTATextToShow}
            lottieHeight={250}
            lottieWidth={300}
            CTAClickFn={ctaClickHandler}
          />
        </div>
      </>
    ),
  });
};

export default OneClickAutoLimitEnhance;
